import { render } from "./WhatsappCtasModal.vue?vue&type=template&id=59a79dec"
import script from "./WhatsappCtasModal.vue?vue&type=script&lang=ts"
export * from "./WhatsappCtasModal.vue?vue&type=script&lang=ts"

import "./WhatsappCtasModal.vue?vue&type=style&index=0&id=59a79dec&lang=scss"
script.render = render

export default script